import { useHistory } from 'quartz-routing/react-router';
import { PortalsAppLayout } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppLayout = ({
  children
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(PortalsAppLayout, {
    history: history,
    children: children
  });
};